import { render, staticRenderFns } from "./M_resource.vue?vue&type=template&id=2b1fc53d&scoped=true&"
import script from "./M_resource.vue?vue&type=script&lang=js&"
export * from "./M_resource.vue?vue&type=script&lang=js&"
import style0 from "./M_resource.vue?vue&type=style&index=0&id=2b1fc53d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1fc53d",
  null
  
)

export default component.exports